import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type ECouponDetailResponse = OAISchema['ECouponDetailResponse'];

export interface ECouponDataSource {
  getECouponDetail(eCouponId: string): Promise<ECouponDetailResponse>;
}

export class ECouponDataSourceImpl implements ECouponDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getECouponDetail(eCouponId: string) {
    return this.client.request<ECouponDetailResponse>({
      url: `/api/non-login/v1/e-coupon/${eCouponId}`,
      method: 'get',
    });
  }
}

export const eCouponDataSource = new ECouponDataSourceImpl();
